import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Background from "../../components/Background";
import Container from "../../components/Container";
import Header from "../../components/Header";
import style from "./Dash.module.css";
import logo from "./logo.png"; // Importando o logo

const Dashboard = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("moega01");

  return (
    <>
      <Navbar />
      <Header />
      <Background />
      <Container>
        <br />
        
      </Container>
    </>
  );
};

export default Dashboard;
